import script from "./CalendarView.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarView.vue?vue&type=script&setup=true&lang=js"

import "./CalendarView.vue?vue&type=style&index=0&id=4a774f37&lang=scss"

const __exports__ = script;

export default __exports__